export default "__VITE_ASSET__12e8f50a__"